import React from 'react';
const Edit = (props) => {
  return (
    <div>
      I'm the auto-generated Player Info block! There is no need to edit me.
    </div>
  );
};
export default Edit;
